common.View.create('shop::website.modules.shopProducts.index.Products', {

    onDOMLoad()
    {
        this.initScrollButton();
    },

    initScrollButton()
    {
        $(window).scroll(() => {
            // Show scroll button?
            if ($(window).scrollTop() > 500) {
                this.element.find('.scroll-button').fadeIn('fast');
            } else {
                this.element.find('.scroll-button').fadeOut('fast');
            }
        });

        this.element.find('.scroll-button').click((e) => {

            // Scroll to top with animation
            $('html, body').animate({
                scrollTop: $('.shop\\:\\:website-modules-shopProducts-index-Products').offset().top - 100
            }, 500);

            e.preventDefault();
        });
    },

    setLoading()
    {
        this.element.addClass('loading');
    },

    updateHtml(ajaxResponse)
    {
        // Replace HTML.
        this.element.replaceWith(ajaxResponse.find('.shop\\:\\:website-modules-shopProducts-index-Products'));

        //
        common.View.reinit();
    },

});
